import React from "react";
import { useDispatch } from "react-redux";
import { setTheme } from "../slices/configSlice";
import { themes, ThemeType } from "../assets/themeConfig";
import "./ThemeSwitchModal.less";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export default function ThemeSwitchModal({ isOpen, onClose }: Props) {
    const dispatch = useDispatch();

    if (!isOpen) return null;

    return (
        <div className="theme-modal-overlay">
            <div className="theme-modal">
                <button className="button-close" onClick={onClose}>&times;</button>
                <div className="header">
                    <h2>Design auswählen</h2>
                </div>
                <div className="themes">
                    {themes.map((theme) => (
                        <div
                            key={theme.id}
                            className="theme-option"
                            onClick={() => {
                                dispatch(setTheme(theme.id as ThemeType));
                                localStorage.setItem("theme", theme.id);
                                onClose();
                            }}
                        >
                            <div className="preview-image">
                                <img
                                    src={theme.themePreview}
                                    alt={`Vorschau für ${theme.name}`}
                                />
                            </div>
                            <div className="name">{theme.name}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
